module.exports = __webpack_public_path__ + "img/comments.5d8d4afa.png";